<template>
  <div>
    <span v-for="item in routes" v-bind:key="item.id">
      <a href="#" @click="onClick(item.id)" class="breadcrumb-link">{{
        item.name
      }}</a
      >/
    </span>
  </div>
</template>

<script>
import '../../styles/breadcrumbs.css'

export default {
  name: 'breadcrumbs',

  props: {
    routes: {
      type: Array,
      required: true,
    },
  },

  methods: {
    onClick(id) {
      this.$emit('click', id)
    },
  },
}
</script>
